<input
  #searchInput
  (mousedown)="$event.stopPropagation()"
  (focus)="setPopoverVisibility(true)"
  (keydown)="onKeyDownWithinInput($event)"
  (keyup)="onKeyUpWithinInput($event, searchInput.value)"
  [attr.data-test]="'header_search_input'"
  [placeholder]="'GLOBAL.QUICK_SEARCH' | translate"
  class="search-input input-field"
  type="text" />

<ng-template #dialogTemplate>
  @if (popoverVisible && minCharsReached) {
    <div class="viewport" (keydown.escape)="closeDialog()">
      <eop-quick-access-results
        [compact]="false"
        [results]="currentResults"
        [searchInProgress]="searchInProgress"
        (resultClicked)="selected($event)"
        [(selectedResult)]="selectedResult"></eop-quick-access-results>
    </div>
  }
</ng-template>
